Namespace('Settings.Views.ChatbotConfiguration')

class Settings.Views.ChatbotConfiguration.IntentRowView extends Backbone.View
  template: JST["backbone/templates/settings/chatbot_configuration/intents_table_row"]
  tagName: 'tr'

  DISABLED_MODIFIER = 'DISABLED'
  MIN_NOTE_LENGTH = 20

  events:
    'click #close': 'onClose'
    'click #save_note': 'onSaveNote'
    'input #add_note': 'checkSaveButton'
    'shown #add_note': 'focusNote'

  initialize: (@options = {}) ->
    @intent = @options.model
    @username = @options.username

  render: =>
    @$el.html(@template( intent: @intent, rowIsDisabled: @rowIsDisabled ))
    @$el.find('select').chosen(width: '200px', disable_search: true).change(@openNoteModal)
    @delegateEvents(@events);
    @

  focusNote: =>
    @$el.find("#note_text").focus()

  openNoteModal: (event, params) =>
    @modifierSelected = params.selected
    @$el.find('#add_note').modal('toggle')

  onClose: =>
    @render()

  onSaveNote: =>
    @note_reason = @$el.find('#note_text').val()
    @updateIntent()
    @trigger('intent:updated')

  updateIntent: =>
    @$el.find('#add_note').modal('toggle')
    dateNow = new Date().format('YYYY-MM-DD hh:mm:ss Z')
    @intent.set(selected: @modifierSelected, updated_at: dateNow, updated_by: @username, update_reason: @note_reason)
    @render()

  checkSaveButton: (event, params) =>
    enabler = (@focusNote().val().length || '') < MIN_NOTE_LENGTH
    @$el.find('#save_note').prop('disabled', enabler)
    if enabler then @$el.find('#save_note').addClass('save-disabled') else @$el.find('#save_note').removeClass('save-disabled')

  rowIsDisabled: () =>
    if @intent.get('selected') == DISABLED_MODIFIER
      'disabled'
    else
      ''
